module.exports = __webpack_public_path__ + "1f28cad0ea140a056b746b74025d2fa4.MP3";